var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          _vm.editRow.type === "add"
            ? _vm.$t("config-manager::operate-config::新增目标")
            : _vm.$t("config-manager::operate-config::编辑目标"),
        visible: _vm.visible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "150px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("config-manager::operate-config::选择团队"),
                    prop: "teamId",
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      options: _vm.teams,
                      placeholder: _vm.$t(
                        "config-manager::operate-config::请选择团队"
                      ),
                      props: {
                        value: "id",
                        label: "name",
                        children: "children",
                        checkStrictly: true,
                      },
                      disabled: _vm.editRow.type === "edit",
                    },
                    on: { change: _vm.getWorkers },
                    model: {
                      value: _vm.form.teamId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "teamId", $$v)
                      },
                      expression: "form.teamId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "target" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "config-manager::operate-config::团队目标金额"
                            )
                          ) +
                          " "
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t(
                              "config-manager::operate-config::targetTips"
                            ),
                            placement: "bottom",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "icon-a-01wenhao iconfont-el",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      placeholder: _vm.$t(
                        "config-manager::operate-config::targetholder"
                      ),
                      min: 0,
                      max: 9999999,
                      precision: 2,
                      controls: false,
                    },
                    on: { change: _vm.changeTarget },
                    model: {
                      value: _vm.form.target,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "target", $$v)
                      },
                      expression: "form.target",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "config-manager::operate-config::员工目标成交额"
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t(
                            "config-manager::operate-config::userTarget"
                          ),
                          placement: "bottom",
                        },
                      },
                      [_c("i", { staticClass: "icon-a-01wenhao iconfont-el" })]
                    ),
                  ],
                  1
                ),
              ]),
              _c("z-table", {
                attrs: {
                  columns: _vm.columns,
                  data: _vm.workers,
                  pagination: false,
                  showHeader: "",
                  maxHeight: 450,
                },
                scopedSlots: _vm._u([
                  {
                    key: "target",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            controls: false,
                            min: 0,
                            max: 9999999,
                            precision: 2,
                          },
                          on: { change: _vm.calcTotal },
                          model: {
                            value: row.target,
                            callback: function ($$v) {
                              _vm.$set(row, "target", $$v)
                            },
                            expression: "row.target",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }